import script from "./AssetsCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssetsCell.vue?vue&type=script&lang=ts&setup=true"

import "./AssetsCell.vue?vue&type=style&index=0&id=c95e3744&lang=sass"

const __exports__ = script;

export default __exports__